/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
const theme = {
  appearances: {
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    }
  },
  rules: [],
  tokens: {
    borderBottomColor: 'transparent',
    borderBottomWidth: 0,
    buttonClearance: 32,
    gutter: null,
    nextIcon: PaletteIconChevronRight,
    previousIcon: PaletteIconChevronLeft,
    space: 0
  }
}
export default theme
